{
  "postTrading": {
    "empty": "Отсутствуют события по опционам",
    "infoText": "Инфо",
    "total": "Всего",
    "columns": {
      "option": "Опцион",
      "options": "Опционы",
      "stocks": "Акции",
      "sum": "Сумма",
      "price": "Цена",
      "event": "Событие",
      "date": "Дата"
    },
    "events": {
      "OPEXP": "Истёк",
      "OPEXC": "Исполнен",
      "OPASN": "Рассчитан",
      "expired": "Истёк",
      "exercises": "Исполнен",
      "assigned": "Рассчитан"
    },
    "errors": {
      "postTradingEvents": "Не удалось получить события по опционам"
    }
  }
}
